export default {
    NO_PLANTING_DATE: 'Template cannot be displayed because "Planting Date" info is missing',
    NO_DATA_FOR_DATE_RANGE: 'No data available for the selected date range',
    NO_DATA_FOR_LAST_30_DAYS: 'No data available for the last 30 days'
}